import { DEV_AUTH_STATE } from "@/lib/auth-types";

export interface ResolveClientBrandIdInput {
	authBrandId?: string | null;
	brandIdOverride?: string | null;
	isBrandSwitchLoading?: boolean;
	switchedBrandId?: string | null;
}

export const DEV_PLACEHOLDER_BRAND_ID = DEV_AUTH_STATE.brand?.id ?? null;

export function isDevPlaceholderBrandId(brandId: string | null | undefined) {
	return Boolean(brandId) && brandId === DEV_PLACEHOLDER_BRAND_ID;
}

export function resolveClientBrandId({
	authBrandId = null,
	brandIdOverride = null,
	isBrandSwitchLoading = false,
	switchedBrandId = null,
}: ResolveClientBrandIdInput) {
	if (brandIdOverride) {
		return brandIdOverride;
	}

	if (switchedBrandId) {
		return switchedBrandId;
	}

	if (isBrandSwitchLoading) {
		return null;
	}

	if (isDevPlaceholderBrandId(authBrandId)) {
		return null;
	}

	return authBrandId ?? null;
}